<script lang="ts">
	//Design system components
	import { Col, Container, Row, SelectCard, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	// Services
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let editableObject;

	const selectButtons = [
		{
			id: 1,
			title: capFirstChar($format('mode_heat')),
			selected: false,
			icon: 'fal fa-temperature-sun',
			value: 'heating',
		},
		{
			id: 2,
			title: capFirstChar($format('mode_cool')),
			selected: false,
			icon: 'fal fa-temperature-snow',
			value: 'cooling',
		},
	];

	const setMode = async (mode) => {
		//cooling heating
		editableObject.thermostat.type = mode;
	};
</script>

<Container class="pb-0" padding="scrollPaddings">
	<Text element="h2" class="mb-m">{$format('choose_thermostat_type')}</Text>
	<Row class="mb-md-l mb-sm-m">
		{#each selectButtons as button, i (button.id)}
			<Col xs={'6'} sm={'6'} md={'6'} lg={'6'}>
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					class="width-full"
					title={button.title}
					selected={button.value === editableObject.thermostat.type}
					variant="radio"
					on:click={() => setMode(button.value)}
					icon={button.icon}
				/>
			</Col>
		{/each}
	</Row>
</Container>
